import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const ApproachSection = () => {
    const { t } = useLanguage();
    return (
        <section id="approach" className="scroll-mt-24 bg-pine-800 py-12 text-cream md:py-20" aria-labelledby="approach-title" data-testid="approach-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl">
                    <Overline>{t.approach.overline}</Overline>
                    <h2 id="approach-title" className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                        {t.approach.title}
                    </h2>
                </Reveal>
                <div className="mt-12 grid gap-10 sm:grid-cols-2 md:mt-16 lg:grid-cols-4 lg:gap-8">
                    {t.approach.steps.map((step, i) => (
                        <Reveal key={step.title} delay={Math.min(i * 0.08, 0.4)}>
                            <div className="border-t border-gold-500/40 pt-6" data-testid={`approach-step-${i + 1}`}>
                                <span className="font-display text-5xl font-light text-gold-500" aria-hidden="true">
                                    0{i + 1}
                                </span>
                                <h3 className="mt-4 text-xl font-semibold">{step.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-cream/70">{step.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.2} className="mt-12">
                    <a
                        href="#appointment"
                        data-testid="approach-book-cta"
                        className="inline-flex min-h-[48px] items-center rounded-full bg-gold-500 px-7 text-sm font-semibold text-ink transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold-600 active:scale-95"
                    >
                        {t.ctas.session}
                    </a>
                </Reveal>
            </div>
        </section>
    );
};

export default ApproachSection;
